module.exports = __webpack_public_path__ + "img/_54A6762.9c0fb67e.jpg";